module.exports = __webpack_public_path__ + "media/placeholder-images/placeholder_4-d3c672c2.jpg";